<div [class.blurred]="showForm">
    <div class="docks">
        <button class="docks-button" *ngFor="let dock of docksDescription$ | async"
            (click)="toggleQueueByDock(dock.id!)">
            {{dock.description}}
        </button>
    </div>

    <div *ngIf="dockNumberToQueue > 0" class="container-queue">
        <h3 class="dock-title">Doca {{ dockNumberToQueue - 20 }}</h3>
        <ng-container *ngIf="(filteredTrips$ | async) as trips">
            <table *ngIf="trips?.length && trips.length > 0" class="dock-table">
                <thead>
                    <tr>
                        <th>Ordem</th>
                        <th>Viagem</th>
                        <th>Tipo</th>
                        <th>Destino</th>
                        <th>Início previsto</th>
                        <th>Saída prevista</th>
                        <th>TAKT (Viagem Extra)</th>
                        <th>Status</th>
                        <th>Ações</th>
                    </tr>
                </thead>
                <tbody>
                    <tr *ngFor="let dockDetails of trips; let i = index">
                        <td>{{ dockDetails.queueOrder }}</td>
                        <td>{{ dockDetails.viagem }}</td>
                        <td>{{ dockDetails.tipo }}</td>
                        <td>{{ dockDetails.destino }}</td>
                        <td>{{ dockDetails.inicioLCB }}</td>
                        <td>{{ dockDetails.saidaLCB }}</td>
                        <td>{{ dockDetails.extra }}</td>
                        <td>{{ dockDetails.status }}</td>
                        <td>
                            <div class="move-buttons">

                                <button class="action-button" (click)="moveUp(trips[i], trips)"
                                    [class.invisible]="i === 0">
                                    ↑
                                </button>

                                <button class="action-button" (click)="moveDown(trips[i], trips)"
                                    [class.invisible]="i === trips.length - 1">
                                    ↓
                                </button>
                                <button class="action-button" (click)="deleteTripById(dockDetails.viagem)">
                                    Excluir
                                </button>
                            </div>

                        </td>
                    </tr>
                </tbody>
            </table>
        </ng-container>
    </div>

    <div class="container-available-trips">
        <div class="trips-queue" [class.blurred]="showForm">
            <h3 class="available-trips-title">Viagens disponíveis</h3>
            <div class="divider"></div>
            <table *ngIf="showTable" class="trips-table">
                <thead>
                    <tr>
                        <th>Número da Viagem</th>
                        <th>Tipo</th>
                        <th>Destino</th>
                        <th>Início previsto</th>
                        <th>Saída prevista</th>
                        <th>TAKT (Viagem Extra)</th>
                        <th>Ações</th>
                    </tr>
                </thead>
                <tbody>
                    <tr *ngFor="let trip of availableTrips$ | async">
                        <td>{{ trip.viagem }}</td>
                        <td>{{ trip.tipo }}</td>
                        <td>{{ trip.destino }}</td>
                        <td>{{ trip.inicioLCB }}</td>
                        <td>{{ trip.saidaLCB }}</td>
                        <td>{{ trip.extra }}</td>
                        <td>
                            <button (click)="toggleForm(trip.viagem)">Adicionar viagem</button>
                        </td>
                    </tr>
                </tbody>
            </table>
            <div class="footer">
                <button class="list-button" (click)="toggleTable()">
                    {{ showTable ? "Fechar janela" : "Listar viagens" }}
                </button>
            </div>
        </div>
    </div>

    <div *ngIf="showForm" class="overlay">
        <form (submit)="onSubmit()">


            <section class="form-inputs">
                <div>
                    <label for="dockNumber">Docas (expedição):</label>
                    <select id="dockNumber" name="dockNumber" type="number" [(ngModel)]="dockNumber" required
                        (ngModelChange)="onDockNumberChange()">
                        <option *ngFor="let dock of expeditionDocks$ | async" [value]="dock.id">{{dock.description}}
                        </option>
                    </select>
                </div>

                <span class="dock-info" *ngIf="dockDescription$ | async as dockDescription">
                    Doca selecionada: {{ dockDescription }}
                </span>

                <div class="form-divider"></div>

                <div>
                    <label for="tripNumber">Número da viagem:</label>
                    <input id="tripNumber" name="tripNumber" type="number" [(ngModel)]="tripNumber" required
                        (ngModelChange)="onTripNumberChange()">
                </div>
            </section>

            <div class="form-info" *ngIf="tripDetails$ | async as tripDetails">
                <span> 
                <div class="trip-info">
                        <span>Viagem: {{ tripDetails.viagem }}</span>
                        <span>Destino: {{ tripDetails.destino }}</span>
                        <span>Tipo: {{ tripDetails.tipo }}</span>
                    </div>
                    <div class="trip-interval">
                        <ng-container *ngIf="tripDetails.extra == null; else extraTemplate">
                          <span>Início LCB: {{ tripDetails.inicioLCB }}</span>
                          <span>Saída LCB: {{ tripDetails.saidaLCB }}</span>
                        </ng-container>
                      
                        <ng-template #extraTemplate>
                          <span>TAKT (Viagem Extra): {{ tripDetails.extra }}</span>
                        </ng-template>
                      </div>
                      
                </span>
            </div>

            <div class="form-divider"></div>

            <div class="form-buttons">
                <button class="save-btn" type="submit">Vincular Viagem</button>
                <button class="close-btn" (click)="toggleForm()">X</button>
            </div>
        </form>
    </div>
</div>